// src/constants.js

// Auth constants
export const AUTH_TOKEN_KEY = "token";
export const AUTH_USER_ID_KEY = "userId";
export const AUTH_REFRESH_TOKEN_KEY = "refreshToken"; // Nueva constante para refresh token